module.exports = __webpack_public_path__ + "static/media/PGDCA.0060168b.pdf";